<template>
  <div v-if="recomDevis">
    <p class="has-text-grid-1 has-text-weight-bold is-size-14px pb-10">
      {{$t('recapRecom.titreRecap')}}
    </p>
    <div class="card mb-20 is-min-height-650px">
      <PageDeGardeRecap :recom="recomDevis" :point-de-vente="pointDeVente"/>
    </div>
    <div class="card mb-20 is-min-height-650px">
      <CartoGeneral :recom-devis="recomDevis" :panneaux="panneaux" :point-de-vente="pointDeVente"/>
    </div>
    <div
      v-for="(panneau, index) in panneauxFiltres"
      class="card mb-20 is-min-height-650px"
      :key="index">
      <RecapPanneau :panneau="panneau" :index="index"/>
    </div>
    <div class="card mb-20 is-min-height-650px">
      <RecapBudgetaire :recom-devis="recomDevis" :panneaux="panneaux" :societe="societe"/>
    </div>
  </div>
</template>

<script>
import PageDeGardeRecap from './PageDeGardeRecap.vue';
import CartoGeneral from './CartoGeneral.vue';
import RecapPanneau from './RecapPanneau.vue';
import RecapBudgetaire from './RecapBudgetaire.vue';
import { LISTE_CATEGORIES_HONORAIRE } from '@/configuration/configPanneau';

export default {
  components: {
    PageDeGardeRecap,
    CartoGeneral,
    RecapPanneau,
    RecapBudgetaire,
  },
  props: {
    societe: Object,
    recomDevis: Object,
    panneaux: {
      type: Array,
      default: () => [],
    },
    pointDeVente: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {};
  },
  computed: {
    panneauxFiltres() {
      const data = this.panneaux
        .filter(p => p.categorie && !LISTE_CATEGORIES_HONORAIRE.includes(p.categorie.libelle) && p.actif);
      if (this.panneaux.some(p => p.estPanneauSousContrat && p.actif)) {
        return data;
      }
      return data.filter(p => !p.estPanneauSousContrat);
    },
  },
}
</script>
